import {ContentEditableHtmlEditorPlugin} from '@frontapp/editor-html';

interface CreateMaybeIgnorePasteAsTextPreferencePluginOptions {
  getShouldPasteAsText: () => boolean;
  onPasteAsTextIgnored?: () => void;
}
export function createMaybeIgnorePasteAsTextPreferencePlugin(
  options: CreateMaybeIgnorePasteAsTextPreferencePluginOptions,
): ContentEditableHtmlEditorPlugin {
  return {
    handleDataTransfer(dataTransfer, editService, element) {
      const shouldPasteAsText = options.getShouldPasteAsText();

      // If the user doesn't want to paste as text, nothing for us to do.
      if (!shouldPasteAsText) {
        return false;
      }

      const html = dataTransfer.getData('text/html');
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const tableCells = doc.querySelectorAll('table td');
      const hasComplexTable = tableCells.length > 1;
      // If the pasted HTML doesn't contain a table, nothing to do.
      if (!hasComplexTable) {
        return false;
      }

      editService.insertDirtyHtml(html);
      options.onPasteAsTextIgnored?.();
      return true;
    },
  };
}
